import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="grid min-h-screen place-items-center bg-background px-6 text-foreground" data-testid="payment-cancel-page">
      <div className="w-full max-w-md text-center">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-secondary text-muted-foreground">
          <XCircle className="h-9 w-9" />
        </div>
        <h1 className="mt-6 text-2xl font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>Checkout cancelled</h1>
        <p className="mt-2 text-sm text-muted-foreground">Nothing was charged. Your current plan is unchanged.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Button asChild className="h-12 rounded-xl px-6" data-testid="payment-cancel-retry-btn"><Link to="/upgrade">Back to plans</Link></Button>
          <Button asChild variant="outline" className="h-12 rounded-xl px-6"><Link to="/chat">Keep chatting</Link></Button>
        </div>
      </div>
    </div>
  );
}
